// apps/academy/src/main.tsx
import { ThemeProvider, ToastContainer } from '@neuroforge/ui'
import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@neuroforge/ui/theme/globals.css'
import App from './App'
import { bootstrapAcademySession } from './lib/academy-bootstrap'
import { createAcademyQueryClient } from './lib/academy-query-client'

// Sentry
const sentryDsn = import.meta.env.VITE_SENTRY_DSN_ACADEMY
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: true,
  })
} else if (import.meta.env.DEV) {
  console.info('[sentry] disabled (no VITE_SENTRY_DSN_ACADEMY)')
}

// Initialize the store's auth-in-progress flag synchronously, before route guards mount.
// The callback route is deliberately exempt so it retains ownership of #nf_token.
void bootstrapAcademySession()

const { client: queryClient } = createAcademyQueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
        <ToastContainer />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
